export const COLUMNS_HEADERS = {
  fileName: { sortable: true },
  model: {
    translatable: true,
    sortable: true,
    filterable: true,
    filterableData: { 1: 'delivery', 2: 'laboratory' },
  },
  createdAt: { sortable: true },
};
